export const PASSWORD_HASH = 'f74efabef12ea619e30b79bddef89cffa9dda494761681ca862cff2871a85980';

export const hashString = async (input) => {
  const trimmed = input.trim();

  if (!trimmed) {
    throw new Error('Password is required.');
  }

  if (typeof window === 'undefined' || !window.crypto || !window.crypto.subtle) {
    throw new Error('Secure context required for password verification.');
  }

  const encoder = new TextEncoder();
  const data = encoder.encode(trimmed);
  const hashBuffer = await window.crypto.subtle.digest('SHA-256', data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map((b) => b.toString(16).padStart(2, '0')).join('');
};

export const verifyPassword = async (input) => {
  const hashedInput = await hashString(input);
  return hashedInput === PASSWORD_HASH;
};

